import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export const getDocumentProperties = (documentId, siteId) => {
  return get(`${url}/leasingDocument/${documentId}/${siteId}/document-properties`);
};

export function getPropertyDetails(propId) {
  return get(`${url}/leasingoffers/asset/property/${propId}/detail`);
}

export const updateDocumentProperties = (documentId, siteId, documentProperties) => {
  return post(`${url}/leasingDocument/${documentId}/${siteId}/update-document-properties`, {
    documentId,
    siteId,
    documentProperties
  });
};
